import { IoOptionsOutline } from 'react-icons/io5'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { themedUseStyletron } from '../../../theme/customTheme';

const OverviewPanel: React.FC<{}> = (props: any) => {
    const [css, theme] = themedUseStyletron();
  return (
          <OverviewPanelWrapper height={theme.appSizes.xSmallAppHeight} {...props}>
            <IoOptionsOutline className={css({
                fontSize: '30pt',
                color: theme.colors.accent500
            })}   />
        </OverviewPanelWrapper>
        );
};

export default OverviewPanel;